'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalDrink = function MapsLocalDrink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
  );
};
MapsLocalDrink = (0, _pure2.default)(MapsLocalDrink);
MapsLocalDrink.displayName = 'MapsLocalDrink';
MapsLocalDrink.muiName = 'SvgIcon';

exports.default = MapsLocalDrink;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/maps/local-drink.js
// module id = 3236
// module chunks = 0